/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelItemWithVisibilityMetadata } from '../../models/travel-item-with-visibility-metadata';

export interface TravelControllerGetTravel$Params {
  id: number;
}

export function travelControllerGetTravel(http: HttpClient, rootUrl: string, params: TravelControllerGetTravel$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetTravel.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItemWithVisibilityMetadata;
      }>;
    })
  );
}

travelControllerGetTravel.PATH = '/travel/{id}';
